import { SaleActivityType, SaleStatus } from "../api/psc";

export const SaleStatusConstants = [
    {
        id: SaleStatus.PENDING,
        title: "در انتظار",
        color: "#d48404",
    },
    {
        id: SaleStatus.DONE,
        title: "پایان یافته",
        color: "#1d8249",
    },
    {
        id: SaleStatus.CANCELLED,
        title: "کنسل شده",
        color: "#ba1313",
    },
];

export const SaleActivityTypeConstants = [
    {
        id: SaleActivityType.NOTE,
        title: "نظر",
        color: "#237d48",
    },
    {
        id: SaleActivityType.REMINDER,
        title: "یادآور",
        color: "#c98d1e",
    },
    {
        id: SaleActivityType.TASK,
        title: "وظیفه",
        color: "#1e68c9",
    },
];
